import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes.js';

export class MainController {
  $http;

  awesomeGroups = [];
  newGroup = '';

  constructor($http, AuthSvc, $state) {
    this.$http = $http;

    // redirect to main if already logged in
    AuthSvc.isLoggedIn(function(loggedIn) {
      if(!loggedIn) {
        $state.go('login');
      } else {
        AuthSvc.getCurrentUser(function(u) {
          if(u.rootGroups && u.rootGroups[0] && u.rootGroups[0].id) {
            var params = {ctxId: u.rootGroups[0].id,
              groupId: u.rootGroups[0].id};
            $state.go('group.view.summary', params);
          } else {
            $state.go('me.personal');
          }
        });
      }
    });
  }

  $onInit() {
    // this.$http.get('/api/groups')
    //   .then(response => {
    //     this.awesomeGroups = response.data;
    //   });
  }
}

MainController.$inject = ['$http', 'AuthSvc', '$state'];

// Import the template
import mainTemplate from './main.pug';

export default angular.module('georgeApp.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: mainTemplate,
    controller: MainController
  })
  .name;
